import LsdApiModel from './global/LsdApiModel';

export default class ExpenseIdModel extends LsdApiModel {
	static get path(): string {
		return '/expenses/ids/{?id}';
	}
}
